const changeLog = [
  {
    version: "05.11.07",
    issues: [
      {id: "", description: "Converted less frequently used pages to lazy loading to improve initial load performance and bundle size."}
    ]
  },
  {
    version: "05.11.06",
    issues: [
      {id: "", description: "Removed all unneeded references to reduce bundle size and improve performance."}
    ]
  },
  {
    version: "05.11.06",
    issues: [
      {id: "GCOBSV5-597", description: "Fixed Observation Report defect where exactly six defect types in a section would cause that section not to display."}
    ]
  }
];

export default changeLog;
